import { render, staticRenderFns } from "./ParametreFacturation.vue?vue&type=template&id=1b74dfd9&scoped=true"
import script from "./ParametreFacturation.vue?vue&type=script&lang=js"
export * from "./ParametreFacturation.vue?vue&type=script&lang=js"
import style0 from "./ParametreFacturation.vue?vue&type=style&index=0&id=1b74dfd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b74dfd9",
  null
  
)

export default component.exports